export const ADD_INGREDIENT="ADD_INGREDIENT";
export const REMOVE_INGREDIENT="REMOVE_INGREDIENT";
export const UPDATE_PRICE="UPDATE_PRICE";
export const RESET_INGREDIENT="RESET_INGREDIENT";
export const LOAD_ORDERS="LOAD_ORDERS";
export const LOAD_ORDERS_FAILED="LOAD_ORDERS_FAILED";

export const AUTH_SUCCESS="AUTH_SUCCESS"
export const AUTH_LOGOUT="AUTH_LOGOUT"
export const AUTH_FAILED="AUTH_FAILED"
export const AUTH_LOADING="AUTH_LOADING"